import { useNavigate } from "react-router-dom";
import { useEnvironment } from "../../customHooks/useEnvironment";
import { Icon } from "../icons/icon";

export const MobileHeader = ({
  title,
  backTo,
}: {
  title?: string;
  backTo?: string | "-1";
}) => {
  const { environment } = useEnvironment();

  const navigate = useNavigate();

  return (
    <>
      {environment === "mobile" ? (
        <div className="text-white z-[997] bg-white bg-light-green-bgg md:hidden min-h-[44px] flex items-center px-4" />
      ) : undefined}

      {title ? (
        <div className="bg-white py-4 text-center md:hidden text-base font-bold border-b flex items-center px-5">
          {backTo ? (
            <button
              type="button"
              onClick={() => {
                if (backTo === "-1") {
                  navigate(-1);
                } else {
                  navigate(backTo);
                }
              }}
              className="absolute left-5"
            >
              <Icon
                svg="caret-down"
                width={24}
                height={24}
                className="rotate-90"
              />
            </button>
          ) : undefined}
          <h1 className="flex-1 text-center line-clamp-1 text-ellipsis max-w-[250px] mx-auto capitalize">
            {title}
          </h1>
        </div>
      ) : undefined}
    </>
  );
};
